import React from 'react';
import { styled, Switch } from '@mui/material'



function StyledSwitch(props) {
    const Android12Switch = styled(Switch)(({ theme }) => ({
        padding: 8,
        '& .MuiSwitch-track': {
            borderRadius: 22 / 2,
            backgroundColor: props.disabled ? "#ccc" : "#e0e0e0",
            opacity: 1,
            '&:before, &:after': {
                content: '""',
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                width: 16,
                height: 16,
            }
        },
        '& .MuiSwitch-thumb': {
            boxShadow: 'none',
            width: 16,
            height: 16,
            margin: 2,
            backgroundColor: props.disabled ? "#bdbdbd" : (props.checked ? "rgba(43, 137, 252, 1)" : "#ffff"),
        },
    }));

    return (
        <Android12Switch {...props} />
    )
}

export default StyledSwitch